module.exports = __webpack_public_path__ + "static/media/img_empty_fav.170a2a20.png";